import React from "react";
import styles from "./styles.module.scss";

const NoResultsSection = ({ title, text, link, linkText }) => {
  return (
    <div className={styles.noResultsSection}>
      {title && <div className={styles.noResultsTitle}>{title}</div>}
      {text && (
        <div className={styles.noResultsText}>
          {text}
          {link && (
            <>
              {" "}
              <a href={link}>{linkText || "Learn more"}</a>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default NoResultsSection;
